export const quosaTags = {
    "VN": "Vendor",
    "DOI": "DOI",
    "DP": "Unknown other date",
    "DTBS": "Search",
    "ES": "Unknown",
    "GUID": "GUID",
    "FAU": "Full author",
    "IN": "Author",
    "IP": "Unknown",
    "IS": "Issue",
    "JT": "Journal title",
    "MH": "Keyword",
    "OS": "Journal",
    "SO": "Journal",
    "PG": "Pages",
    "PL": "Publication location",
    "PT": "Publication type",
    "RN": "Research notes",
    "SB": "Unknown",
    "YR": "Publication year",
    "WURL": "URL",
    "UI": "UI",
    "VI": "Volume",
    "rtyp": "Publication type",
    "AID": "Additional ID",
    "DEP": "Date",
    "EDAT": "Date",
    "JID": "Journal ID",
    "LR": "Unknown",
    "MHDA": "Date",
    "OT": "Original title",
    "OTO": "Unknown",
    "PHST": "Unknown",
    "PST": "Print status",
    "OWN": "Unknown",
};
